const ViewFormInfo = ({ data }) => {
    const { eventId, iccId, createdAt, formData } = data;
    return (
        <div className="tab-pane__content">
            <h5 className="tab-pane__title">Information</h5>
            <div className="row">
                <div className="col-md-6">
                    <div className="row mb-3">
                        <div className="col-6">ICC ID</div>
                        <div className="col-6">
                            <div className="table_value_pre">
                                <strong>{iccId}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="row mb-3">
                        <div className="col-6">Event ID</div>
                        <div className="col-6">
                            <div className="table_value_pre">
                                <strong>{eventId}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="row mb-3">
                        <div className="col-6">Create Date</div>
                        <div className="col-6">
                            <div className="table_value_pre">
                                <strong>{new Date(createdAt).toUTCString()}</strong>
                            </div>
                        </div>
                    </div>
                </div>

                {Object.entries(JSON.parse(formData)).map(([key, value], index) => {
                    return (
                        <div key={index} className="col-md-6">
                            <div className="row mb-3">
                                <div className="col-6 text-capitalize">{key}</div>
                                <div className="col-6">
                                    <div className="table_value_pre">
                                        <strong>{value}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ViewFormInfo;
